import React, { useCallback, useMemo } from 'react';
import ErrorIcon from '@atlaskit/icon/core/migration/error';
import { token } from '@atlaskit/tokens';
import { toFlagId } from '@atlassian/jira-flags';
import Flag from '@atlassian/jira-flags/src/common/ui/components/ak-flag';
import { useFlagService } from '@atlassian/jira-flags/src/services';
import { fromFlagId, DISMISS_COMMAND } from '@atlassian/jira-flags/src/services/types';
import { FormattedI18nMessage } from '@atlassian/jira-formatted-i18n-message/src/ui/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages.tsx';

export const CREATE_CATEGORY_ERROR_FLAG_ID = toFlagId('create-category-error-flag');

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const { dismissFlag } = useFlagService();

	const onDismissed = useCallback(() => {
		dismissFlag({
			command: DISMISS_COMMAND,
			id: CREATE_CATEGORY_ERROR_FLAG_ID,
		});
	}, [dismissFlag]);

	const handleContactAdminClick = useCallback(() => {
		fireUIAnalytics(createAnalyticsEvent({}), 'link clicked', 'contactAdministrator');
	}, [createAnalyticsEvent]);

	return useMemo(
		() => (
			<Flag
				id={fromFlagId(CREATE_CATEGORY_ERROR_FLAG_ID)}
				icon={<ErrorIcon spacing="spacious" label="error" color={token('color.icon.danger')} />}
				title={formatMessage(messages.noPermissionToCreateCategoryTitle)}
				description={
					<FormattedI18nMessage
						message={formatMessage(messages.createCategoryNoPermissions, {
							linkStart: '{linkStart}',
							linkEnd: '{linkEnd}',
						})}
						componentsMapping={{
							link: ({ children }) => (
								<a
									href="/secure/ContactAdministrators!default.jspa"
									target="_blank"
									onClick={handleContactAdminClick}
								>
									{children}
								</a>
							),
						}}
					/>
				}
				onDismissed={onDismissed}
				messageId="business-list.ui.list-view.category-cell.edit-category-cell.create-error-flag.flag"
				messageType="transactional"
			/>
		),
		[formatMessage, onDismissed, handleContactAdminClick],
	);
};
